module.exports = __webpack_public_path__ + "img/remove.daa85444.svg";